/* KISHI KAISEI — révélations + interactions (à toute épreuve) */
(function(){
  'use strict';
  function show(el){ el.classList.add('in'); }
  function inView(el, m){ var r=el.getBoundingClientRect(); return r.top < window.innerHeight*m && r.bottom > -40; }
  function sweep(m){ var els=document.querySelectorAll('.reveal:not(.in)'); for(var i=0;i<els.length;i++){ if(inView(els[i],m)) show(els[i]); } }
  function kanji(){
    var els=document.querySelectorAll('[data-kbg]');
    for(var i=0;i<els.length;i++){ var el=els[i], p=el.parentNode.getBoundingClientRect(); var off=(window.innerHeight/2 - (p.top + p.height/2))*0.08; el.style.transform='translateY(-50%) translateY('+off.toFixed(1)+'px)'; }
  }
  function boot(){
    sweep(0.98); kanji();
    var ticking=false;
    window.addEventListener('scroll', function(){ if(!ticking){ requestAnimationFrame(function(){ sweep(0.92); kanji(); ticking=false; }); ticking=true; } }, {passive:true});
    window.addEventListener('resize', function(){ sweep(0.95); kanji(); }, {passive:true});
    setTimeout(function(){ sweep(1.15); }, 1400);
    setTimeout(function(){ var els=document.querySelectorAll('.reveal:not(.in)'); for(var i=0;i<els.length;i++){ if(els[i].getBoundingClientRect().top < window.innerHeight){ show(els[i]); } } }, 3800);
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  (function(){
    if(window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return;
    var btns=document.querySelectorAll('.btn-primary, .btn-ghost, .kku-btn, .kkh-btn, .kkpr-btn, .kksn-btn');
    for(var i=0;i<btns.length;i++){ (function(b){
      b.addEventListener('mousemove', function(e){ var r=b.getBoundingClientRect(); b.style.transform='translate('+((e.clientX-(r.left+r.width/2))*0.18).toFixed(1)+'px,'+((e.clientY-(r.top+r.height/2))*0.3).toFixed(1)+'px)'; });
      b.addEventListener('mouseleave', function(){ b.style.transform=''; });
    })(btns[i]); }
  })();
})();

/* ---------- KISHI KAISEI — fiche produit : bandeau description + bouton bundle ---------- */
(function(){
  'use strict';

  function fillDescMarquee(){
    var tracks=document.querySelectorAll('.kk-pdp .kk-marquee__track');
    for(var i=0;i<tracks.length;i++){
      var tr=tracks[i], mq=tr.parentElement;
      if(!mq || !mq.clientWidth) continue;
      if(!tr.getAttribute('data-kkbase')){ tr.setAttribute('data-kkbase', tr.innerHTML); }
      var base=tr.getAttribute('data-kkbase'); var guard=0;
      while(tr.scrollWidth < mq.clientWidth*2 && guard<10){ tr.innerHTML += base; guard++; }
    }
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', fillDescMarquee); } else { fillDescMarquee(); }
  window.addEventListener('load', fillDescMarquee);
  var rt; window.addEventListener('resize', function(){ clearTimeout(rt); rt=setTimeout(fillDescMarquee, 200); }, {passive:true});

  /* Neutralise le lien du bouton bundle : le href /cart/... (qui file au checkout) est déplacé dans data-kkcart. Le bouton ne peut donc JAMAIS naviguer. */
  function neutralize(a){
    if(!a) return;
    var h=a.getAttribute('href')||'';
    if(h.indexOf('/cart/')===0){ a.setAttribute('data-kkcart', h); a.setAttribute('href','javascript:void(0)'); a.setAttribute('role','button'); }
  }
  function setupBundleLinks(){
    var btns=document.querySelectorAll('.kk-xsell-btn');
    for(var i=0;i<btns.length;i++){
      neutralize(btns[i]);
      if(window.MutationObserver && !btns[i].__kkObs){
        btns[i].__kkObs=true;
        var obs=new MutationObserver(function(muts){ for(var j=0;j<muts.length;j++){ neutralize(muts[j].target); } });
        obs.observe(btns[i], {attributes:true, attributeFilter:['href']});
      }
    }
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', setupBundleLinks); } else { setupBundleLinks(); }
  window.addEventListener('load', setupBundleLinks);

  function refreshCount(){
    fetch('/cart.js', { headers:{ 'Accept':'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){ var els=document.querySelectorAll('[data-cart-count]'); for(var i=0;i<els.length;i++){ els[i].textContent=c.item_count; } })
      .catch(function(){});
  }

  function openCartDrawer(){
    var d=document.querySelector('[data-cart-drawer]');
    var st=window.themeSettings||{};
    if(st.cartType==='drawer' && d){
      fetch('/?sections=cart-drawer')
        .then(function(r){ return r.json(); })
        .then(function(data){
          var html=data && data['cart-drawer'];
          if(html){ var doc=new DOMParser().parseFromString(html,'text/html'); var fresh=doc.querySelector('[data-cart-drawer]'); if(fresh && d){ d.innerHTML=fresh.innerHTML; } }
          if(d){ d.hidden=false; requestAnimationFrame(function(){ d.classList.add('is-open'); }); document.body.style.overflow='hidden'; }
        })
        .catch(function(){ if(d){ d.hidden=false; d.classList.add('is-open'); document.body.style.overflow='hidden'; } });
    }
    refreshCount();
  }

  document.addEventListener('click', function(e){
    var btn=e.target.closest('.kk-xsell-btn');
    if(!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if(btn.getAttribute('data-busy')) return;
    var path=btn.getAttribute('data-kkcart')||btn.getAttribute('href')||'';
    var m=path.match(/\/cart\/([^?#]+)/);
    if(!m) return;
    var items=m[1].split(',').map(function(pair){ var p=pair.split(':'); return { id:parseInt(p[0],10), quantity:parseInt(p[1]||'1',10) }; }).filter(function(it){ return it.id; });
    if(!items.length) return;
    if(!btn.getAttribute('data-label')){ btn.setAttribute('data-label', btn.textContent); }
    var orig=btn.getAttribute('data-label');
    btn.setAttribute('data-busy','1'); btn.style.pointerEvents='none'; btn.textContent='Ajout…';
    /* On lit d'abord le panier : le lien du bundle contient toujours le produit de la page,
       et /cart/add.js ADDITIONNE. Sans ce contrôle, un produit déjà au panier y était ajouté
       une seconde fois (2 couteaux au lieu d'1). On ne demande donc que ce qui manque. */
    fetch('/cart.js', { headers:{ 'Accept':'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var deja={};
        var lignes=(cart && cart.items) || [];
        for(var i=0;i<lignes.length;i++){ deja[lignes[i].variant_id]=(deja[lignes[i].variant_id]||0)+lignes[i].quantity; }
        var manquants=[];
        for(var j=0;j<items.length;j++){
          var reste=items[j].quantity-(deja[items[j].id]||0);
          if(reste>0){ manquants.push({ id:items[j].id, quantity:reste }); }
        }
        if(!manquants.length) return null;
        return fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify({ items: manquants }) })
          .then(function(r){ return r.json().then(function(b){ if(!r.ok) throw b; return b; }); });
      })
      .then(function(ajout){
        btn.textContent = ajout ? 'Ajouté ✓' : 'Déjà au panier';
        openCartDrawer();
        setTimeout(function(){ btn.textContent=orig; btn.style.pointerEvents=''; btn.removeAttribute('data-busy'); }, 1900);
      })
      .catch(function(){
        btn.textContent='Indisponible';
        btn.style.pointerEvents=''; btn.removeAttribute('data-busy');
        setTimeout(function(){ btn.textContent=orig; }, 2200);
      });
  }, true);
})();
